<template>
    <div class="contrato-page">
        <!-- Header/Navbar -->
        <b-navbar variant="light" fixed="top" class="shadow-sm">
            <b-container>
                <b-navbar-brand>
                    <img src="@/assets/logo.png" alt="Logo" height="40">
                </b-navbar-brand>
                
                <b-navbar-nav class="ml-auto">
                    <b-nav-text class="mr-3 d-none d-md-block text-muted">
                        <b-icon-file-text class="mr-1" />
                        <strong>Contrato:</strong> {{ ficha.codigo }}
                    </b-nav-text>
                    
                    <b-button variant="outline-danger" size="sm" @click="sair" class="btn-logout">
                        <b-icon-box-arrow-right class="mr-1" />
                        <span class="d-none d-sm-inline">Sair</span>
                    </b-button>
                </b-navbar-nav>
            </b-container>
        </b-navbar>

        <!-- Conteúdo Principal -->
        <b-container fluid class="main-content">
            <b-row>
                <b-col cols="12">
                    <!-- Navegação por Tabs -->
                    <b-card no-body class="shadow-sm">
                        <b-tabs card pills>
                            <!-- Aba: Visão Geral -->
                            <b-tab title="Visão Geral" active>
                                <template #title>
                                    <b-icon-house-door /> <span class="d-none d-md-inline">Visão Geral</span>
                                </template>
                                
                                <template v-if="ficha && ficha.id">
                                    <dashboard :fichaId="ficha.id" />
                                    
                                    <b-card class="mt-4 shadow-sm">
                                        <b-card-title>Detalhes do Contrato</b-card-title>
                                        <detalhes-proposta :fichaId="ficha.id" :classeDestaque="true" />
                                    </b-card>
                                </template>
                            </b-tab>

                            <!-- Aba: Meus Boletos -->
                            <b-tab title="Meus Boletos">
                                <template #title>
                                    <b-icon-receipt /> <span class="d-none d-md-inline">Meus Boletos</span>
                                </template>
                                
                                <template v-if="ficha && ficha.id">
                                    <financiamento :fichaId="ficha.id" />
                                </template>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import DetalhesProposta from './Components/DetalhesProposta.vue';
import Financiamento from './Components/Financiamento.vue';
import Dashboard from './Components/Dashboard.vue';

export default {
    components: {
        DetalhesProposta,
        Financiamento,
        Dashboard
    },
    data() {
        return {
            ficha: null
        };
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated'])
    },
    mounted() {
        // Verificar se está autenticado
        if (!this.isAuthenticated) {
            this.$router.push({ name: 'Acesso' });
            return;
        }
        
        // Obter ficha dos params ou do Vuex
        this.ficha = this.$route.params.id ? this.$route.params : this.$store.state.auth.ficha;
        
        if (!this.ficha || !this.ficha.id) {
            this.$router.push({ name: 'Acesso' });
        }
    },
    methods: {
        ...mapActions('msgErro', { exibirMsgErro: 'exibirMsgErro' }),
        ...mapActions('msgSucesso', { exibirMsgSucesso: 'exibirMsgSucesso' }),
        ...mapActions('auth', ['clearAuth']),
        
        sair() {
            this.clearAuth();
            this.$router.push({ name: 'Acesso' });
        }
    }
};
</script>

<style scoped>
.contrato-page {
    background-color: #f8f9fa;
    min-height: 100vh;
    padding-top: 70px;
    padding-bottom: 40px;
}

.main-content {
    padding-top: 20px;
}

.navbar {
    background-color: #ffffff !important;
    border-bottom: 1px solid #e0e0e0;
}

.btn-logout:hover {
    background-color: #dc3545;
    color: white;
    border-color: #dc3545;
}

.card {
    border-radius: 8px;
}

.destaque {
    background: #f0f0f0;
    padding: 1rem;
    border-radius: 8px;
}

/* Responsividade mobile */
@media (max-width: 768px) {
    .contrato-page {
        padding-top: 60px;
        padding-bottom: 20px;
    }
    
    .main-content {
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Contrato/Contrato.vue